import { render, staticRenderFns } from "./TumoralPhenomena.vue?vue&type=template&id=ac38e2b6&"
import script from "./TumoralPhenomena.vue?vue&type=script&lang=js&"
export * from "./TumoralPhenomena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports